import React from 'react';

export default class PageLoadBoundary extends React.Component<
  { children: React.ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render(): React.ReactNode {
    if (!this.state.failed) return this.props.children;
    // Reload the document to pick up the current asset manifest after a stale
    // or failed chunk. Never silently relabel another design as this variant.
    return (
      <main className="container py-5" role="alert">
        <h1>This page could not load.</h1>
        <p>Reload to try again.</p>
        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
          Reload page
        </button>
      </main>
    );
  }
}
